module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /Users/nathan/dev/piggybk/aws-amplify/node_modules/axios/index.js
// module id = 448
// module chunks = 0 1